import { State, Action, Selector } from '@ngxs/store';
import { NotificationsApiService } from './services/notifications-api.service';
import { NotificationModele } from './modeles/notification.modele';
import { NotificationType } from './modeles/notification-type';
import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config.service';
import { get } from 'lodash';
import { MassNotificationModele } from './modeles/mass-notifications.modele';

const defaultState = {
  notifications: [],
  massNotifications: []
};

export interface NotificationStateModel {
  notifications: Array<NotificationModele>;
  massNotifications: Array<MassNotificationModele>;
}

export class LoadNotifications {
  static type = '[Notification] LoadNotifications';
}

export class DeleteNotification {
  static type = '[Notification] DeleteNotification';
  constructor(public idNotification: string) {}
}

export class AddNotificationDebug {
  static type = '[Notification] AddNotificationDebug';
  constructor(public notificationType: NotificationType) {}
}

export class DeleteMassNotification {
  static type = '[Notification] DeleteMassNotification';
  constructor(public idNotification: string) {}
}

export class LoadMassNotifications {
  static type = '[Notification] LoadMassNotification';
}

export class AddMassNotificationDebug {
  static type = '[Notification] AddMassNotificationDebug';
  constructor(public feature: string, public code: string) {}
}

@Injectable()
@State<NotificationStateModel>({
  name: 'notification',
  defaults: defaultState
})
export class NotificationState {
  private readonly DEBUG_PREFIX = 'debug-';

  constructor(
    private readonly _notificationApiService: NotificationsApiService,
    private readonly _appConfigService: AppConfigService
  ) {}

  @Selector()
  static getNotifications(state: NotificationStateModel) {
    return [...state.notifications];
  }

  @Selector()
  static getMassNotifications(state: NotificationStateModel) {
    return [...state.massNotifications];
  }

  @Action(DeleteNotification)
  async deleteNotification({ patchState, getState }, { idNotification }: DeleteNotification) {
    if (!idNotification) {
      return;
    }

    const state = getState();
    if (!idNotification.startsWith(this.DEBUG_PREFIX)) {
      await this._notificationApiService.deleteNotification(idNotification).toPromise();
    }
    patchState({
      notifications: state.notifications.filter(o => o.id !== idNotification)
    });
  }

  @Action(AddNotificationDebug)
  async addNotificationDebug({ patchState, getState }, { notificationType }) {
    const newNotifications = getState().notifications;
    const newId = this.DEBUG_PREFIX + Math.floor(Math.random() * 1000);
    newNotifications.push({ id: newId, type: notificationType });
    patchState({
      notifications: newNotifications
    });
  }

  @Action(LoadNotifications)
  async loadNotifications({ patchState }) {
    const notifications = await this._notificationApiService.getNotifications().toPromise();
    patchState({
      notifications: notifications
    });
  }

  @Action(LoadMassNotifications)
  async loadMassNotifications({ patchState }) {
    patchState({
      massNotifications: get(this._appConfigService, 'configData.massNotifications', [])
    });
  }

  @Action(DeleteMassNotification)
  async deleteMassNotification({ getState, patchState }, { idNotification }: DeleteMassNotification) {
    if (!idNotification) {
      return;
    }

    const state = getState();
    if (!idNotification.startsWith(this.DEBUG_PREFIX)) {
      await this._notificationApiService.deleteMassNotification(idNotification).toPromise();
    }
    patchState({
      massNotifications: state.massNotifications.filter(o => o.id !== idNotification)
    });
  }

  @Action(AddMassNotificationDebug)
  async addMassNotificationDebug({ patchState, getState }, { feature, code }: AddMassNotificationDebug) {
    const newNotifications = getState().massNotifications;
    const newId = this.DEBUG_PREFIX + Math.floor(Math.random() * 1000);
    newNotifications.push({ id: newId, code: code, feature: feature });
    patchState({
      massNotifications: newNotifications
    });
  }
}
